import React, { useEffect, useState, useCallback, useRef } from "react";
import moment from "moment";
import { useTranslation } from 'react-i18next';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useAppContext }from "contexts/AppContext"


// Storybook
import { Row, Col, Card, CardBody, Container } from "stories/layout";
import { Input, DatePicker } from "stories/forms";
import { Typography, Button, Link, IconButton, Modal } from "stories/components";
import { TableAuto } from "stories/tables"

// App
import { PageWrapper, PageHeader, PageContainer } from "components/Page"
import { httpGetTransactions, httpGetPrivateStockTransactions, httpGetDiarySummary } from "services/transactions"
import StockMarketSelect from "components/Forms/StockMarketSelect/StockMarketSelect"
import StockSelect from "components/Forms/StockSelect/StockSelect"
import StockPrivateSelect from "components/Forms/StockPrivateSelect/StockPrivateSelect"
import TransactionTypeSelect from "components/Forms/TransactionTypeSelect/TransactionTypeSelect"
import InvestmentTypeSelect from "components/Forms/InvestmentTypeSelect/InvestmentTypeSelect"
import PortfolioSelectStore from "components/Forms/PortfolioSelect/PortfolioSelectStore"
import PortfolioSelect from "components/Forms/PortfolioSelect/PortfolioSelect"
import ReportCurrencyNote, { useReportCurrencyInfo } from "components/ReportCurrencyNote/ReportCurrencyNote"
import { reportPortfolioInit } from "store/activePortfolios"


import { useAuthContext } from "contexts/AuthContext"

import { getDate } from "services/datetime"
import { round, roundScaleDecimals, thousandFormat } from "services/helpers"
import { renderTransactionTypeBadge } from "utils/transactionTypeBadge";
import { set } from "date-fns";
import { filterEventStoreDefs } from "@fullcalendar/core";

import Info from "components/Info/Info.js";
import { setIn } from "formik";

const DiarySummary = ({match, history}, props) => {
  
  const { t } = useTranslation();
  const { getTransactionType, getPortfolioCurrency } = useAppContext()
  const portfolio = useStoreState((state) => state.portfolio?.portfolio);

  const getBasicDataObjects = useStoreActions((actions) => actions.stocks.getObjects);
  const myAccount = useStoreState((state) => state.account?.account);
  
  const purchases = useStoreState((state) => state.purchases?.objects);
  const setPurchases = useStoreActions((actions) => actions.purchases.setObjects);
  const count = useStoreState((state) => state.purchases?.count);
  const setCount = useStoreActions((actions) => actions.purchases.setCount);

  
  const [currentDate, setCurrentDate] = useState(moment().format('YYYY-MM-DD'));
  const [diarySummary, setDiarySummary] = useState();

  const portfolios = useStoreState((state) => state.portfolio?.portfolios);
  const portfoliosLoading = useStoreState((state) => state.portfolio?.loading);
  // The SALKKU filter starts from the active portfolios and follows them (#1409).
  const activePortfolios = useStoreState((state) => state.portfolio?.activePortfolios);
  const activeKey = useStoreState((state) => state.portfolio?.activeKey);
  const appliedActiveKey = useRef(activeKey);
  // Bumped when the filter is set from new active portfolios, so the load runs with it.
  const [activeLoad, setActiveLoad] = useState(0);
  
  const handleDateChange = event => {
    setCurrentDate(event.target.value)
  }
  
  // Table
  const [loading, setLoading] = useState(false)
  const [checked, setChecked] = useState([])

  const [filters, setFilters] = useState({
    limit: 50,
    offset:0,
    ordering: "-date_transaction",
    // stock_market: "XHEL",
    portfolio: reportPortfolioInit(activePortfolios).portfolio,
    selected_portfolios: reportPortfolioInit(activePortfolios).selected_portfolios

  })

  // The server reports in the common currency of the portfolios, or in EUR when they differ.
  const { currency: reportCurrency } = useReportCurrencyInfo(filters?.selected_portfolios)

  useEffect(() => {
    // The first load is done by the paging effect below with the initial filters.
    if (appliedActiveKey.current === activeKey) {
      return
    }
    appliedActiveKey.current = activeKey
    const init = reportPortfolioInit(activePortfolios)
    setFilters(s => ({
      ...s,
      portfolio: init.portfolio,
      selected_portfolios: init.selected_portfolios,
    }))
    setActiveLoad(n => n + 1)
  }, [activeKey])

    //----------------------------UPDATE securities ----------------------------------------------------
    useEffect(() => {
      if (true) {
        // console.log("PRIVATE basic_data")
        // getPrivateBasicDataObjects()
  
        let param ={
          ...filters,
          stock_market:filters?.stock_market,
          related_model_type: filters?.related_model_type,
          all_related_model_types: true
        }
  
        if (filters?.related_model_type == "30" ){
          param ={...param, type: null}
        }

        //if related_model_type is not in [10, 20, 30, 40] then it is subs
        if (filters?.related_model_type !== "10" && filters?.related_model_type !== "20" && filters?.related_model_type !== "30" && filters?.related_model_type !== "40" && filters?.related_model_type !== "" && filters?.related_model_type !== null && filters?.related_model_type !== undefined  ){
          param ={...param, related_model_type: "30", second_type: filters?.related_model_type}
        }

        getBasicDataObjects(param)
      }
      else {
      getBasicDataObjects({stock_market:filters?.stock_market, all_related_model_types: true})
      }
      // if (values)
      // setFieldValue('stock', null)
    }, [filters?.stock_market, filters.related_model_type, filters?.fund_type, filters?.portfolio, filters?.selected_portfolios])
  
  const getTransactions = () => {

    // let portfolio = [];
    // if (filters.portfolio) {
    //   portfolio = filters.portfolio.map(item => {
    //       console.log(item)
    //       return {
    //           portfolio: item?.id ? item?.id: item
    //       }
    // })  
    // }
    let params = {
      ...filters,
      date_transaction__date__gte: filters?.date_transaction__date__gte ? moment(filters?.date_transaction__date__gte).format("YYYY-MM-DD") : undefined,
      sdate_transaction__date__lte: filters?.date_transaction__date__lte ? moment(filters?.date_transaction__date__lte).format("YYYY-MM-DD") : undefined,
      stock_market: filters?.stock_market ? filters?.stock_market : undefined,
      selected_portfolios: null
    }
    if (filters?.stock?.id && filters?.stock?.id !== "") {
      // separete related_model_type and related_model_id from stock.id using "," first part is related_model_type and second is related_model_id
      const related_model_type = filters?.stock?.id?.split(",")[0]
      const related_model_id = filters?.stock?.id?.split(",")[1]
      params = {
        ...params,
        related_model_type: related_model_type,
        related_model_id: related_model_id,
      }
      if (related_model_type !== "10" && related_model_type !== "20" && related_model_type !== "30" && related_model_type !== "40" ){
        params ={...params, related_model_type: 30}
      }
    }
    //if related_model_type is not in [10, 20, 30, 40] then it is subs
    if (filters?.related_model_type !== "10" && filters?.related_model_type !== "20" && filters?.related_model_type !== "30" && filters?.related_model_type !== "40" && filters?.related_model_type !== "" && filters?.related_model_type !== null && filters?.related_model_type !== undefined && filters?.stock?.id === undefined ){
      params ={...params, related_model_type: "30", second_type: filters?.related_model_type}
    }

    setLoading(true)


    httpGetTransactions(params).then(res => {

      setPurchases(res?.data?.results)
      setCount(res?.data?.count)
        setLoading(false)
    })
    httpGetDiarySummary(params).then(response => {
      setDiarySummary(response?.data)
      console.log(response)
    })


    
  }


  
  useEffect(() => {
    getTransactions()

  }, [filters?.limit, filters?.offset, filters?.ordering, activeLoad ])
// }, [filters?.limit, filters?.offset, filters?.ordering, filters?.portfolio, filters?.related_model_type, filters?.stock_market, filters?.date_transaction__date__gte, filters?.date_transaction__date__lte, filters?.type ])
  
  useEffect(() => {
    const selectedPortfolioIds = [];
    filters.selected_portfolios.forEach(item => selectedPortfolioIds.push(item.id));
    setFilters(s => ({
      ...s,
      portfolio: selectedPortfolioIds?selectedPortfolioIds:[portfolio?.id],
    }))
  }, [filters.selected_portfolios])
  
  const headers = [
    { label: t("diary_transactions_id", "ID"), key: "id", sortable: true},
    { label: t("diary_transactions_date", "Päivä"), key: "date_transaction", sortable: true },
    { label: t("diary_transactions_batch_id", "Erän ID"), key: "batch_id", sortable: true},
    { label: t("diary_transactions_type", "Tyyppi"), key: "type", sortable: true},
    { label: t("diary_transactions_label", "Tunnus"), key: "stock__ticker_symbol", sortable: true},
    { label: t("diary_transactions_name", "Nimi"), key: "stock__name", sortable: true},
    // { label: t("diary_transactions_stock_market", "Pörssi"), key: "stock_market", sortable: true},
    // { label: t("diary_transactions_balance", "Saldo"), key: "balance"},
    { label: t("diary_transactions_quantity", "Määrä"), key: "quantity", sortable: true},
    { label: t("diary_transactions_price", "Hinta/kpl"), key: "price", sortable: true},
    { label: t("diary_transactions_price_total", "Hinta yht."), key: "price_total", sortable: true},
    { label: t("diary_transactions_commission_total", "Kulut yht."), key: "commission_total", sortable: true},
    { label: t("diary_transactions_value_total", "Yhteensä"), key: "value_total", sortable: true},
    { label: t("diary_transactions_currency", "Valuutta"), key: "currency_label", sortable: true},
    { label: t("diary_transactions_portfolio", "Salkku"), key: "portfolio"},
    { label: t("diary_transactions_user", "Tehnyt"), key: "user__full_name"},
    // { label: t("diary_transactions_batch", "Erästä jäljellä"), key: "batch"},
    // { label: t("diary_transactions_original_batch", "Erän alkup. koko*"), key: "original_batch"},
    { label: t("diary_transactions_comment", "Kommentti"), key: "notes"},
    // { label: t("diary_transactions_balance", "Balance"), key: "balance"},
    // { label: t("diary_transactions_actions", ""), key: "actions"},
  ];
  const SummaryHeaders = [
    { label: t("diary_transactions_type", "Tapahtuman tyyppi"), key: "type", sortable: false},
    // { label: t("diary_transactions_label", "Tunnus"), key: "stock__ticker_symbol", sortable: false},
    { label: t("diary_transactions_name", "Nimi"), key: "stock__name", sortable: false},
    // { label: t("diary_transactions_balance", "Saldo"), key: "balance"},
    { label: t("diary_transactions_quantity", "Määrä"), key: "quantity", sortable: false},
    { label: t("diary_transactions_currency_label", "Valuutta"), key: "currency_label", sortable: false},
    { label: t("diary_transactions_commission_total", "Kulut"), key: "commission_total", sortable: false},
    { label: t("diary_transactions_price_total", "Hankinta/myyntihinta"), key: "price_total", sortable: false},
    { label: t("diary_transactions_value_total", "Yhteensä"), key: "value_total", sortable: false},
    // { label: t("diary_transactions_actions", ""), key: "actions"},
  ];
  
  const paginationPrevious = () => {
    let offset = filters?.offset - filters?.limit;
    if (offset < 0) {
      offset = 0;
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }
  
  const paginationNext = () => {
    let offset = filters?.offset + filters?.limit;
    if (offset > filters?.count) {
      return
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }
  
  const getTableRows = useCallback(() => {
    return purchases && purchases.map((row, index) => {
      // const transactionTypeValue = getTransactionType(row?.type)?.value
      // let transactionTypeCell;


      // if (transactionTypeValue === "Buy") {
      //   transactionTypeCell = (<span className="text-danger font-weight-bold">{t("transactionTypeValue_2", transactionTypeValue)}</span>)
      // }
      // else if (transactionTypeValue === "Sell") {
      //   transactionTypeCell = (<span className="text-success font-weight-bold">{t("transactionTypeValue_3", transactionTypeValue)}</span>)
      // }
      // else if (transactionTypeValue === "Split") {
      //   transactionTypeCell = (<span className="text-info font-weight-bold">{t("transactionTypeValue_20", transactionTypeValue)}</span>)
      // }
      // else {
      //   transactionTypeCell = (<span className="text-info font-weight-bold">{t("transactionTypeValue_41", transactionTypeValue)}</span>)
      // }

      const transactionTypeCell = renderTransactionTypeBadge(row?.type, t, getTransactionType);







      const stockNameCell = (
        <><span className={!row?.type? "font-weight-bold": null}>{row?.related_model?.name}</span></>
      )
      return {
        ...row,
        quantity: {
          content: thousandFormat(roundScaleDecimals(row?.quantity, 2)),
          className: "text-right"
        },
        price: {
          content: thousandFormat(roundScaleDecimals(Math.abs(row?.price), 2)),
          className: "text-right"
        },
        price_total: {
          content: thousandFormat(round(row?.price_total, 2)),
          className: "text-right"
        },
        commission_total: {
          content: thousandFormat(round(row?.commission_total, 2)),
          className: "text-right"
        },
        value_total: {
          content: thousandFormat(round(row?.value_total, 2)),
          className: "text-right"
        },

        batch_id: row?.batch_id ? row?.batch_id : row?.id,
        original_batch: thousandFormat(row?.original_batch_balance),
        // date_transaction: getDate(row?.date_transaction),
        date_transaction: (
          <>
          {row?.original_purchase_date? <> {getDate(row?.original_purchase_date) + " " }<span className="text-gray ">({getDate(row?.date_transaction)})*</span></>:getDate(row?.date_transaction)}
          </>
        ),
        portfolio: row?.portfolio?.name,
        // currency_label: row?.related_model?.currency_label,
        currency_label: row?.currency_label,
        type: transactionTypeCell,
        stock__ticker_symbol: row?.related_model?.ticker_symbol,
        stock__name: stockNameCell,
        stock_market: row?.stock_market,
        user__full_name: row?.user?.full_name,
        batch: row?.batch_balance,
        actions:(
                    <><Button className="btn-sm" color="secondary" >{t("edit_button","Muokkaa")}</Button></>
                ) 
      }
    })
  }, [purchases, currentDate])
  

  const getSummaryTableRows = useCallback(() => {
    let buy_total_quantity_summary = 0
    let buy_total_price_summary = 0
    let buy_total_commission_summary = 0
    let buy_total_value_summary = 0

    let sell_total_quantity_summary = 0
    let sell_total_price_summary = 0
    let sell_total_commission_summary = 0
    let sell_total_value_summary = 0

    let rows = []
    const summary_name_sell = t("diary_summmary_sell_total", "Myynnit yhteensä")
    const summary_name_buy = t("diary_summary_buy_total", "Ostot yhteensä")

    // if (diarySummary?.sell && diarySummary.buy){
    //   rows = type === "Sell"?  [...diarySummary?.sell] : type==="Buy"? [...diarySummary?.buy] : [];
      
    // } 

    diarySummary?.sell && diarySummary?.sell.map((row) => {
      console.log(row)
      sell_total_quantity_summary += row?.total_quantity
      sell_total_price_summary += row?.total_price
      sell_total_commission_summary += row?.total_commission
      sell_total_value_summary += row?.total_value
      rows.push(row)
    } ) 

    diarySummary?.sell.length > 0 && rows.push({
          related_model: {name:summary_name_sell},
          total_quantity: sell_total_quantity_summary,
          total_price: round(sell_total_price_summary, 2),
          total_commission: round(sell_total_commission_summary, 2),
          total_value: round(sell_total_value_summary, 2),
          type: "summary"
        })

    diarySummary?.sell.length > 0 && rows.push({
      // total_quantity: 0,
      // total_price: "",
      // total_commission: "",
      // total_value: "",
      type: "space",
      related_model: {name:"  -  "}
    })
    // diarySummary?.sell.length > 0 && rows.push({
    //   total_quantity: "",
    //   total_price: "",
    //   total_commission: "",
    //   total_value: "",
    // })
    // diarySummary?.sell.length > 0 && rows.push({
    //   total_quantity: "",
    //   total_price: "",
    //   total_commission: "",
    //   total_value: "",
    // })

    diarySummary?.buy && diarySummary?.buy.map((row) => {
      console.log(row)
      buy_total_quantity_summary += row?.total_quantity
      buy_total_price_summary += row?.total_price
      buy_total_commission_summary += row?.total_commission
      buy_total_value_summary += row?.total_value
      rows.push(row)
    } ) 

    diarySummary?.buy.length >0 && rows.push({
      related_model: {name:summary_name_buy},
      total_quantity: buy_total_quantity_summary,
      total_price: round(buy_total_price_summary, 2),
      total_commission: round(buy_total_commission_summary, 2),
      total_value: round(buy_total_value_summary, 2),
      type: "summary"
    })
    diarySummary?.sell.length > 0 && rows.push({
      // total_quantity: "",
      // total_price: "",
      // total_commission: "",
      // total_value: "",
      type: "space",
      related_model: {name:"  -  "}
    })

    diarySummary && rows.push({
      related_model: {name:t("diary_summary_all_summary", "Kaikki yhteensä")},
      total_quantity: buy_total_quantity_summary - sell_total_quantity_summary,
      total_price: round(buy_total_price_summary, 2) + round(sell_total_price_summary, 2),
      total_commission: round(buy_total_commission_summary, 2) + round(sell_total_commission_summary, 2),
      total_value: round(buy_total_value_summary, 2) + round(sell_total_value_summary, 2),
      type: "summary"
    })

    // for (let i = 0; i < diarySummary?.sell; i++) {
    //   console.log(diarySummary?.sell[i])
    //   sell_total_quantity_summary += diarySummary[i]?.total_quantity
    //   sell_total_price_summary += diarySummary[i]?.total_price
    //   sell_total_commission_summary += diarySummary[i]?.total_commission
    //   sell_total_value_summary += diarySummary[i]?.total_value
    //   rows.push(diarySummary?.sell[i])

    // }
    // const summary_name = t("unmade_split_transactions_list_summary", "Yhteensä")

    // if (rows && rows.length >0){
    //   rows.push({
    //     related_model: {name:summary_name},
    //     total_quantity: total_quantity_summary,
    //     total_price: round(total_price_summary, 2),
    //     total_commission: round(total_commission_summary, 2),
    //     total_value: round(total_value_summary, 2),
    //   })
    // }


    return diarySummary && rows.map((row, index) => {
      const transactionTypeValue = row?.type
      let transactionTypeCell;
      if (transactionTypeValue == "2") {
        transactionTypeCell = (<span className="text-danger font-weight-bold">{t("transactionTypeValue_2", transactionTypeValue)}</span>)
      }
      else if (transactionTypeValue == "3") {
        transactionTypeCell = (<span className="text-success font-weight-bold">{t("transactionTypeValue_3", transactionTypeValue)}</span>)
      }
      else {
        transactionTypeCell = (<span className="text-info font-weight-bold"></span>)
      }



      
      const stockNameCell = (
        <><span className={row?.type== "summary" ? "font-weight-bolder": null} style={{opacity: row?.type == "space" ? 0 : 1 }}>{row?.related_model?.name}</span></>
      )
      const comissionTotalCell = (
        <><span className={row?.type== "summary" ? "font-weight-bolder": null}>{!row?.total_commission? "":thousandFormat(round(row?.total_commission, 2))}</span></>
      )
      const valueTotalCell = (
        <><span className={row?.type== "summary" ? "font-weight-bolder": null}>{!row?.total_value? "":thousandFormat(round(row?.total_value, 2))}</span></>
      )
      const priceTotalCell = (
        <><span className={row?.type== "summary" ? "font-weight-bolder text-right": "text-right"}>{!row?.total_price ? "":thousandFormat(round(row?.total_price, 2))}</span></>
      )
      const quantityCell = (
        <><span className={row?.type== "summary" ? "font-weight-bolder text-right": row?.type =="space"? "pt-3":null} style={row?.type == "space" ?{color: "transparent !important"}: {}}>{row?.total_quantity && thousandFormat(roundScaleDecimals(row?.total_quantity, 2)) }</span></>

      )
      const currencyLabelCell = (
        <><span className={row?.type== "summary" ? "font-weight-bolder": row?.type =="space"? "pt-3":null} style={row?.type == "space" ?{color: "transparent !important"}: {}}>{row?.type !== "space" ? reportCurrency || getPortfolioCurrency(filters?.portfolio[0]):null}</span></>

      )
      return {
        ...row,
        quantity: {
          content: quantityCell, 
          className: "text-right"
        },
        price_total: {
          content: priceTotalCell,
          className: "text-right"
        },
        commission_total: {
          content: comissionTotalCell,
          className: "text-right"
        },
        value_total: {
          content: valueTotalCell,
          className: "text-right"
        },

        currency_label: currencyLabelCell,
        type: transactionTypeCell,
        stock__ticker_symbol: row?.related_model?.ticker_symbol,
        stock__name: stockNameCell,
        stock_market: row?.stock_market,
        actions:(
                    <><Button className="btn-sm" color="secondary" >{t("edit_button","Muokkaa")}</Button></>
                ) 
      }
    })
  }, [diarySummary, currentDate])

   

   



  
  // Filters
  
  const handleChange = ({target}, child) => {
    setFilters(s => ({
      ...s,
      [target?.name]: target.value
    }))
   

  }

  const setFieldValue = (name, value) => {
    setFilters(s => ({
      ...s,
      [name]: value
    }))
  }
  const setSelectFieldValue = (name, value) => {
    setFilters(s => ({
      ...s,
      [name]: value    
    }))
  }
  
  const getFormikInputProps = useCallback(
    name => ({
      name,
      value: filters[name],
      onChange: handleChange
    }),
    [filters, handleChange]
  );
  
  const handleStockMarketChange = ({target}) => {
    
    setFilters(s => ({
      ...s,
      stock_market: target.value,
      stock: null
    }))
  }

  const handleInvestmentTypeChange = ({target}) => {
    if (target.value !== "10" ) {
      setFilters(s => ({
        ...s,
        related_model_type: target.value,
        stock_market: undefined,
        stock: null
      }))

    }
    else {
    setFilters(s => ({
      ...s,
      related_model_type: target.value,
      stock: null
    }))
  }
  }

  const [modalEditOpen, setModalEditOpen] = useState(false)
  useEffect(() => {
    // if (portfolio == null || portfolio == undefined) {
    //   setModalEditOpen(true)
    // }

    if (portfoliosLoading) {
      setModalEditOpen(false)
    }
    else {
    setModalEditOpen(portfolios.length === 0 ? true : false)
    }
  }, [portfolios])

  const [modalEditId, setModalEditId] = useState()
  
  const toggleModalEdit = () => {
    setModalEditOpen(s => !s);
  }
  
  const openModalEdit = (id) => {
    setModalEditOpen(true)
    setModalEditId(id);
  }
  
  const modalEditResolve = () => {
    setModalEditOpen(false);
    setModalEditId(null);
    
  }
  
  const modalEditReject = () => {
    setModalEditOpen(false);
    setModalEditId(null);
  }

  
  const getStockSelect = useCallback(() => {

    return (
      <StockSelect
        {...getFormikInputProps("stock")}
        className="select_multi_select_large"

        label={t("purchase_order_edit_asset_stock", "Arvopaperi")}
        setFieldValue={setSelectFieldValue}
        showAll={true}
        setValueToSelect={true} 
        setFieldValueReturnId={false}
        ratesView={false}
        focused={true}
      />
    )
  }, [filters?.stock_market, filters?.related_model_type, filters?.portfolio, filters?.selected_portfolios, filters?.stock])

  const getInvestmentTypeSelect = useCallback(() => {
    return <InvestmentTypeSelect name="related_model_type" onChange={handleInvestmentTypeChange} showSubsOptions={true} value={filters.related_model_type} />
  }, [filters?.related_model_type, myAccount, filters?.portfolio, filters?.selected_portfolios])
  
  
  return (
    
    <div className="sk_transaktions_list">
        {JSON.stringify(filters)}
        {JSON.stringify(props)}
      
      <PageContainer className="bg-lighter">
      {/* <Typography variant="small">{t("Kirjauksia yhteensä")} {count}{t("kpl")}</Typography> */}
      <Typography bold variant="h3" className="my-3">{t("diary_summary_title", "Yhteenveto")}</Typography>
      <ReportCurrencyNote selected={filters?.selected_portfolios} currency={reportCurrency} className="mb-2" />

      <Row>
        <Col sm="8">
          <TableAuto
            showId={false}
            checkboxes={false}
            headers={SummaryHeaders}
            headerColor={"light"}
            rows={getSummaryTableRows()}
            loading={loading}

          />

        </Col>
      </Row>
      <Row>
        <Col sm="6">

        </Col>
      </Row>
      </PageContainer>



      <Modal
      // title={modalEditPurchaseId > 0 ? t("Muokkaa ostokirjausta") : t("Uusi ostokirjaus")}
      showHeader={false}
      isOpen={modalEditOpen}
      toggleModal={toggleModalEdit}
      size="modal-lg"
    >
        <Info
        objectId={modalEditId}
        handleResolve={modalEditResolve}
        handleReject={modalEditReject}
      />
    </Modal>



      
      {/*JSON.stringify(stocksData)*/}
    </div>
  );
}

export default DiarySummary;
